import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Default from 'react-bootstrap/Row';
import { createResponsiveClasses } from '../utils/create-responsive-classes/create-responsive-classes.esm.js';

const Row = /*#__PURE__*/ forwardRef(({ gap, className, spacingGroup, flexDirection, gx, gy, alignItems, center: _center, ...rest }, ref)=>{
    return jsx(Default, {
        ...rest,
        className: classNames(spacingGroup, className, {
            /**
             * We must us display flex when using the gap utility
             */ 'd-flex': gap || gx || gy
        }, /**
         * We must use flex direction when using the gap utility
         * others the gaps will not be applied
         *
         * The directions are Row and Column which will either align
         * the columns next to each other `row` or in a stack `column`.
         */ createResponsiveClasses({
            bsPrefix: 'flex',
            responsiveDefinitition: flexDirection
        }), createResponsiveClasses({
            bsPrefix: 'gap',
            responsiveDefinitition: gap
        }), createResponsiveClasses({
            bsPrefix: 'gx',
            responsiveDefinitition: gx
        }), createResponsiveClasses({
            bsPrefix: 'gy',
            responsiveDefinitition: gy
        }), createResponsiveClasses({
            bsPrefix: 'align-items',
            responsiveDefinitition: alignItems
        })),
        ref: ref
    });
});

export { Row };
